import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import HomeOverview from './pages/HomeOverview.vue'
import FeatureSelection from './pages/FeatureSelection.vue'
import CamerasSection from './pages/CamerasSection.vue'
import HomeAutomationSection from './pages/HomeAutomationSection.vue'
import EnvironmentalSection from './pages/EnvironmentalSection.vue'
import WindowsSection from './pages/WindowsSection.vue'
import System from './pages/System.vue'
import SystemAndMonitoring from './pages/SystemAndMonitoring.vue'

import LoadingScreen from './sections/LoadingScreen.vue'
import AuthPage from './sections/AuthPage.vue'
import LoginLanding from './sections/LoginLanding.vue'

import HelpSection from './sections/HelpSection.vue'
import WhatAreProtectionLevels from './sections/help/WhatAreProtectionLevels.vue'
import HowDoPetsAffectMySecuritySystem from './sections/help/HowDoPetsAffectMySecuritySystem.vue'
import WhatDoesAccessibilityMean from './sections/help/WhatDoesAccessibilityMean.vue'
import WhatIsAdtPulse from './sections/help/WhatIsAdtPulse.vue'
import WhatIsTotalLevelProtection from './sections/help/WhatIsTotalLevelProtection.vue'
import WhatArePetAlleys from './sections/help/WhatArePetAlleys.vue'
import IndoorCameraGuide from './sections/help/IndoorCameraGuide.vue'
import RemoteDoorLockGuide from './sections/help/RemoteDoorLockGuide.vue'
import WhatIsTrueAdvice from './sections/help/WhatIsTrueAdvice.vue'
import SmokeHelp from './sections/help/SmokeHelpPage.vue'
import CoHelp from './sections/help/CoHelpPage.vue'
import MonitoringOverview from './sections/MonitoringOverview.vue'
import InstallContract from './sections/InstallContract.vue'
import SystemReview from './sections/SystemReview.vue'

import HelpEquipment from './sections/HelpEquipment.vue'
import MonitoringPlans from './sections/MonitoringPlans.vue'

import DiscountModal from './components/DiscountModal/DiscountModal.vue'

import CheckoutInstallation from './sections/CheckoutInstallation.vue'
import CheckoutPersonalInformation from './sections/CheckoutPersonalInformation.vue'
import CheckoutPayment from './sections/CheckoutPayment.vue'
import OrderComplete from './sections/OrderComplete.vue'

import TermsAndConditions from './sections/TermsAndConditions.vue'

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/assessment', component: HomeOverview },
    { path: '/feature-selection', component: FeatureSelection },
    { path: '/cameras', component: CamerasSection },
    { path: '/home-automation', component: HomeAutomationSection },
    { path: '/environmental', component: EnvironmentalSection },
    { path: '/windows', component: WindowsSection },
    { path: '/system', component: System },
    { path: '/system-and-monitoring', component: SystemAndMonitoring },
    { path: '/system-review', component: SystemReview },
    { path: '/checkout', component: CheckoutInstallation },
    //  { path: '/discounts', component: DiscountModal },
    { path: '/checkout/personal-information', component: CheckoutPersonalInformation },
    { path: '/checkout/payment', component: CheckoutPayment },
    { path: '/complete', component: OrderComplete },
    { path: '/terms-and-conditions', component: TermsAndConditions },

    {
      path: '/help',
      component: HelpSection,
      children: [
        { path: 'what-are-protection-levels', component: WhatAreProtectionLevels },
        { path: 'how-do-pets-affect-my-security-system', component: HowDoPetsAffectMySecuritySystem },
        { path: 'what-does-accessibility-mean', component: WhatDoesAccessibilityMean },
        { path: 'what-is-adt-pulse', component: WhatIsAdtPulse },
        { path: 'what-is-total-level-protection', component: WhatIsTotalLevelProtection },
        { path: 'what-are-pet-alleys', component: WhatArePetAlleys },
        { path: 'indoor-camera-guide', component: IndoorCameraGuide },
        { path: 'remote-door-lock-guide', component: RemoteDoorLockGuide },
        { path: 'what-is-true-advice', component: WhatIsTrueAdvice },
        { path: 'smoke-communicator-guide', component: SmokeHelp },
        { path: 'carbon-monoxide-communicator-guide', component: CoHelp },
      ],
    },
    { path: '/help/equipment', component: HelpEquipment },
    { path: '/monitoring-plans', component: MonitoringPlans },

    { path: '/loading', component: LoadingScreen },
    { path: '/login', component: AuthPage },
    { path: '/login-landing', component: LoginLanding },
    { path: '/register', component: AuthPage },
    { path: '/monitoring-overview', component: MonitoringOverview },
    { path: '/install-contract', component: InstallContract },
  ],
})

export default router
